// GearsType
const PINION = 1;
const CROWN  = 2;
const RING   = 3;

// ShaftTypes
const GENERATOR                = 0;
const HSS                    = 1;
const IMS                    = 2;
const LSS                    = 3;
const MAIN_SHAFT             = 4;
const PLANETARY_CAGE_SHAFT   = 5;
const CAGE_SHAFT_UP_WIND     = 6;
const CAGE_SHAFT_DOWN_WIND   = 7;

// GearboxStagesTypes
const PARALLEL_STAGE   = 1;
const PLANETARY_STAGE  = 2;

// GearboxTypes
const PLANETARY = 1;
const PARALLEL  = 2;

export default {
	PINION,
	CROWN,
	RING,
	GENERATOR,
	HSS,
	IMS,
	LSS,
	MAIN_SHAFT,
	PLANETARY_CAGE_SHAFT,
	CAGE_SHAFT_UP_WIND,
	CAGE_SHAFT_DOWN_WIND,
	PARALLEL_STAGE,
	PLANETARY_STAGE,
	PLANETARY,
	PARALLEL
};
